<template>
    <div class="d-flex flex-column align-start">
        <v-checkbox
            v-model="formData.enableUserModification"
            v-tooltip:bottom="$t('allow_users_to_change_settings_note')"
            hide-details
            :label="$t('allow_users_to_change_settings')"
            data-cy="allow-users-to-change-settings"
        />
        <v-checkbox
            v-if="!isTAContract && !isCorpContract"
            v-model="formData.enableAgencyModification"
            v-tooltip:bottom="$t('allow_to_create_sub_agencies_note')"
            hide-details
            :label="$t('allow_to_create_sub_agencies')"
            data-cy="allow-to-create-sub-agencies"
        />
        <v-checkbox
            v-if="!isTAContract && !isCorpContract"
            v-model="formData.allowToConfigureOwnPaymentMethods"
            hide-details
            :label="$t('allow_to_configure_own_payment_plans')"
            data-cy="allow-to-configure-own-payment-plans"
        />
        <v-checkbox
            v-if="!isTAContract && runtimeStore.getCRMOption('asp.option.enable.customFields')"
            v-model="formData.enableUserCustomFieldModification"
            v-tooltip:bottom="$t('allow_users_to_change_custom_settings_note')"
            hide-details
            :label="$t('allow_users_to_change_custom_settings')"
            data-cy="allow-users-to-change-custom-settings"
        />
        <template v-if="runtimeStore.getCRMOption('asp.option.enable.business.trip.documents.generation')">
            <v-checkbox
                v-model="formData.enableBusinessTripDocumentsGeneration"
                hide-details
                :label="$t('enable_generation_of_business_trip_documents')"
                data-cy="enable-generation-of-business-trip-documents"
                @update:model-value="updateBusinessTripDocumentsGenerationSettings"
            />
            <div v-if="formData.enableBusinessTripDocumentsGeneration" class="pl-8">
                <div v-for="dociment in useBusinessTripDocumentsGenerationTypes" :key="dociment.value">
                    <v-checkbox
                        v-model="formData.businessTripDocumentTypesEnabled[dociment.value]"
                        hide-details
                        :label="dociment.title"
                        :data-cy="dociment.value"
                    />
                </div>
            </div>
        </template>
    </div>
</template>
<script setup lang="ts">
    const isTAContract: boolean = inject('isTAContract', false)
    const isCorpContract: boolean = inject('isCorpContract', false)

    const formData = defineModel<any>()
    const {t} = useI18n()

    const updateBusinessTripDocumentsGenerationSettings = () => {
        if (formData.value.enableBusinessTripDocumentsGeneration) {
            formData.value.businessTripDocumentTypesEnabled = {
                BUSINESS_TRIP_PERMIT: true,
                ORDER_FOR_BUSINESS_TRIP: true,
                EXPENSE_REPORT: true,
                WORK_TASK: true,
            }
        } else {
            formData.value.businessTripDocumentTypesEnabled = {
                BUSINESS_TRIP_PERMIT: false,
                ORDER_FOR_BUSINESS_TRIP: false,
                EXPENSE_REPORT: false,
                WORK_TASK: false,
            }
        }
    }

    const useBusinessTripDocumentsGenerationTypes = computed(() => {
        return [
            {value: 'BUSINESS_TRIP_PERMIT', title: t('businessTripDocumentsGenerationTypes.BUSINESS_TRIP_PERMIT')},
            {
                value: 'ORDER_FOR_BUSINESS_TRIP',
                title: t('businessTripDocumentsGenerationTypes.ORDER_FOR_BUSINESS_TRIP'),
            },
            {value: 'EXPENSE_REPORT', title: t('businessTripDocumentsGenerationTypes.EXPENSE_REPORT')},
            {value: 'WORK_TASK', title: t('businessTripDocumentsGenerationTypes.WORK_TASK')},
        ]
    })
</script>
